<template>
  <DialogLayout class="plat-manager-role-catalog"
                title="页面设置"
                v-loading="loading"
                element-loading-text="数据加载中，请稍等...">
    <template v-if="distributeInfo">
      <AuthorityDistributeCatalog ref="distribute"
                                  :catalog-list="distributeInfo.catalogList || []"
                                  :distributes="distributeInfo.distributes">
      </AuthorityDistributeCatalog>
    </template>
    <template v-else>
      <Hint v-if="!loading"
            type="error">
        <div>权限数据加载失败</div>
        <el-button size="mini"
                   type="text"
                   @click="loadDistributeInfo">重新加载</el-button>
      </Hint>
    </template>
    <template v-if="distributeInfo"
              #footer>
      <div class="catalog-footer">
        <div class="extra">
          <el-button size="mini"
                     type="text"
                     @click="handleSelectAll">全选</el-button>
          <span>/</span>
          <el-button size="mini"
                     type="text"
                     @click="handleClearSelection">清空</el-button>
        </div>
        <el-button size="mini"
                   type="primary"
                   :disabled="committing"
                   @click="handleApply">提交设置</el-button>
        <el-button size="mini"
                   type="default"
                   @click="handleClose">取消操作</el-button>
      </div>
    </template>
  </DialogLayout>
</template>

<script>
import DialogLayout from '../../../../../../../widgets/DialogLayout'
import AuthorityDistributeCatalog from '../../../../../../../widgets/authority/AuthorityDistributeCatalog'
import Hint from '../../../../../../../elements/Hint'
export default {
  name: 'PlatManagerRoleCatalog',
  components: {
    DialogLayout,
    AuthorityDistributeCatalog,
    Hint
  },
  props: {
    rowData: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      loading: false,
      distributeInfo: null,
      committing: false
    }
  },
  methods: {
    loadDistributeInfo () {
      this.loading = true
      this.$ajax({
        url: '/workspace/manager/plat/management/peManagerRole/distributeInfo',
        method: 'post',
        data: this.$qs.stringify({
          postId: this.rowData.id
        })
      }).then(response => {
        if (response.data) {
          switch (response.data['responseCode']) {
            case 'SUCCESS': {
              this.distributeInfo = response.data['distributeInfo'] || {}
              break
            }
            default: {
              this.$message.warning(response.data['message'])
              break
            }
          }
        }
      }, () => {
        this.$message.error('请求发送失败，请稍后重试')
      }).finally(() => {
        this.loading = false
      })
    },
    handleSelectAll () {
      let distribute = this.$refs.distribute
      if (distribute) {
        distribute.selectAll()
      }
    },
    handleClearSelection () {
      let distribute = this.$refs.distribute
      if (distribute) {
        distribute.clearSelection()
      }
    },
    handleApply () {
      let distribute = this.$refs.distribute
      if (distribute) {
        distribute.getDistributeCatalogs().then(result => {
          this.committing = true
          this.$ajax({
            url: '/workspace/manager/plat/management/peManagerRole/submitDistribute',
            method: 'post',
            data: this.$qs.stringify({
              postId: this.rowData.id,
              addIds: result.addIds,
              deleteIds: result.deleteIds
            }, {
              arrayFormat: 'repeat'
            })
          }).then((response) => {
            if (response.data) {
              switch (response.data['responseCode']) {
                case 'SUCCESS': {
                  this.$message.success(response.data['message'])
                  this.$nextTick(() => {
                    this.loadDistributeInfo()
                  })
                  break
                }
                default: {
                  this.$message.warning(response.data['message'])
                  break
                }
              }
            }
          }, () => {
            this.$message.error('请求提交失败')
          }).finally(() => {
            this.committing = false
          })
        }).catch(err => {
          this.$message.warning(err.message)
        })
      }
    },
    handleClose () {
      this.$emit('hidePopover')
    }
  },
  mounted () {
    this.loadDistributeInfo()
  }
}
</script>

<style lang="scss">
  .plat-manager-role-catalog {
    height: 100%;
    width: 540px;
    max-width: 100%;
    .authority-distribute-catalog {
      background-color: #fff;
    }
    .catalog-footer {
      position: relative;
      height: 100%;
      & > .extra {
        position: absolute;
        left: 10px;
        top: 50%;
        transform: translateY(-50%);
        color: #606266;
        font-size: 12px;
      }
    }
  }
</style>
